<template>
  <div class="cireadd">
    <div class="body">
      <div class="nav">
        <div class="nav_left" @click="list">
          <van-icon name="arrow-left" style="margin-left: 1rem" />
        </div>
        <van-button
          type="primary"
          @click="send"
          style="
            height: 4rem;
            line-height: 3.6rem;
            height: 3.6rem;
            padding: 0 1rem;
            position: absolute;
            right: 1rem;
            top: .5rem;
          "
          >发表</van-button
        >
      </div>
      <div>
        <van-cell-group>
          <van-field
            v-model="message"
            rows="3"
            autosize
            type="textarea"
            autosize="true"
            placeholder="请输入内容"
          />
        </van-cell-group>
      </div>
      <div class="none">
        <div>
          <van-uploader
            v-model="fileList"
            :after-read="afterRead"
            :max-count="9"
            multiple
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import { Toast } from "vant";
import { Area } from "vant";
export default {
  name: "mine",
  data() {
    return {
      fileList: [],
      message: "",
      imgs: "",
      url: "",
      datalist: {},
    };
  },
  mounted() {
    this.datalist = this.$route.query;
  },
  methods: {
    afterRead(file) {},
    list() {
      this.$router.replace("circle");
    },
    foren() {
      let arr = [];
      const data = new FormData();
      for (var a = 0; a <= this.fileList.length - 1; a++) {
        arr.push(this.fileList[a].file);
        data.append("file[]", this.fileList[a].file);
      }
      this.axios({
        method: "post",
        url: "/api/Alioss/uploadHost",
        data: data,
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=----WebKitFormBoundaryPHA3DHO5JQHbHVkf",
        },
      })
        .then((res) => {
          this.url = res.data.data.url.toString();
        })
        .catch(function (err) {});
    },
    send() {
      this.foren();
      setTimeout(() => {
        this.axios
          .post(
            "/crm/CircleFriends/addCircleFriends",
            qs.stringify({
              userid: this.datalist.userid,
              account_id: this.datalist.account_id,
              content: this.message,
              url: this.url,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.code == 1) {
              Toast(res.data.msg);
              this.$router.replace("/circle");
            }
          })
          .catch(function (err) {});
      }, 4000);
    },
  },
};
</script>
<style scoped>
.nav {
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  position: relative;
}
.van-cell {
  -webkit-box-shadow: 0 0 0 #fff;
  box-shadow: 0 0 0 #fff;
  margin-top: 0%;
}
.none {
  width: 90%;
  margin: 1rem auto;
}
.none > div {
  width: 27rem;
  margin: 0 auto;
}
.nav_left {
  width: 5rem;
  height: 5rem;
}
</style>
